import { render, staticRenderFns } from "./SolicitudesCertificado.vue?vue&type=template&id=cc6531a8&scoped=true"
import script from "./SolicitudesCertificado.vue?vue&type=script&lang=js"
export * from "./SolicitudesCertificado.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesCertificado.vue?vue&type=style&index=0&id=cc6531a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6531a8",
  null
  
)

export default component.exports